import React, { Component } from "react";
import ChatWaveform from "./ChatWaveform";
import axios from "axios";
import ChatSpeechBubble from "./ChatSpeechBubble";
import { numberOfPeopleFilter } from "./MessageFilter";
import telphoneDial from "../static/telephone_dial_sound.wav";
import textToSpeech from "../utils/textToSpeech";
import onHoldMusic from "../static/onHoldMusic.mp3";
import axifyWaveformUser from "../assets/Axify_White_Equalize.json";
import axifyWaveformAxi from "../assets/Axify_Green_Equalize.json";
import axiSymbolWhite from "../assets/axiSymbolWhite.svg";
import {
  applyStoredSessionId,
  clearStoredSessionId,
  storeSessionIdFromResponse,
} from "../utils/sessionTransport";

// Constants
import { APP_CONFIG, VOICE_CONFIG, FAKE_MESSAGES, FAKE_MESSAGES_RPA } from "../constants";

const { BACKEND_URL: backendUrl } = APP_CONFIG;
const { API_KEY: apiKey, REGION: region } = VOICE_CONFIG;
const speechsdk = require("microsoft-cognitiveservices-speech-sdk");
const generateResponseErrorMessage =
  "I'm sorry, something went wrong. Please restart the conversation.";
const TEXT_PROGRESSIVE_FILLER_MIN_DISPLAY_MS = 900;

class ChatMessages extends Component {
  constructor(props) {
    super(props);
    axios.defaults.withCredentials = true;
    applyStoredSessionId();
    this.prevUserSpeech = "";
    this.requestCD = false; // request cool down time, waiting for 1 second before sending next response to backend
    this.timerRef = null;
    this.finishRecognization = false;
    this.audio = new Audio(telphoneDial);
    this.onHoldMusic = new Audio(onHoldMusic);
    this.activeGenerateTurnId = 0;
    this.pendingFinalResponseHandler = null;
    this.isProgressiveFillerPlaying = false;
    this.hasProgressiveFillerPlayed = false;
    this.isFinalResponseReady = false;
    this.progressiveAckStartTimerRef = null;
    this.progressiveAckPollerRef = null;
    this.progressiveTextFillerTimerRef = null;
    this.isProgressiveAckRequestInFlight = false;
    // this.onHoldMusic.volume = Math.max(0, this.onHoldMusic.volume - 0.20);
  }

  state = {
    started: this.props.started,
    systemStatus: "idle",
    recording: false,
    systemMessage: "",
    userMessage: "",
    servicePlace: this.props.servicePlace,
    welcomeAudio: null,
    nameList: "",
    bannerImage: "",
    merchantURL: this.props.merchantURL,
    integrationType: this.props.integrationType,
    lastMessage: "",
    messages: [],
    playing: false,
    role: "assistant",
    waveformData: axifyWaveformAxi,
    calendarData: "",
    axiSpeaking: false,
    voiceSettings: null,
    mappedPronunciation: null,
    elevenLabsVoiceId: "",
    elevenLabsVoiceDisplayName: "",
    elevenLabsVoiceSettings: null,
    elevenLabsLanguageCode: "",
    language: this.props.language,
    mode: this.props.mode || "voice",
    // Text/Audio mode support
    voiceOn: false,
    inputText: "",
    // Shown as a pulsing-dots bubble while Axi is composing a text response.
    isAxiTyping: false,
  };

  // ======================================================================
  // TEXT INPUT FEATURES
  // ======================================================================
  handleInputChange = (event) => {
    this.setState({ inputText: event.target.value });
  };

  handleSend = () => {
    const { inputText } = this.state;
    const trimmed = inputText.trim();
    if (!trimmed) return;
    // Reset recording before adding the message so the streaming-replace
    // logic in addMessages (used by voice partial recognition) does not
    // delete the previous message.
    this.setState(
      { recording: false, userMessage: trimmed, inputText: "", isAxiTyping: true },
      () => {
        this.updateMessages(trimmed, "user");
        this.postGenerateResult();
      }
    );
  };

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.handleSend();
    }
  };

  handleModeSwitch = async () => {
    const nextMode = this.state.mode === "voice" ? "text" : "voice";

    if (nextMode === "text") {
      // Voice -> Text: stop recognizer, keep session/messages.
      if (this.recognizer) {
        try {
          this.recognizer.stopContinuousRecognitionAsync();
        } catch (error) {
          console.warn("Failed to stop recognizer on mode switch:", error);
        }
      }
      this.setState({ mode: "text", recording: false, voiceOn: false });
      return;
    }

    // Text -> Voice: request mic permission, then start recognizer.
    if (typeof this.props.requestMicrophoneAccess === "function") {
      try {
        await this.props.requestMicrophoneAccess();
      } catch (error) {
        console.error("Microphone permission error on mode switch:", error);
        alert(
          "Microphone access is required for voice mode. Please allow microphone access and try again."
        );
        return;
      }
    }
    this.setState({ mode: "voice" }, () => {
      if (!this.recognizer) {
        this.startRecording();
      } else {
        try {
          this.recognizer.startContinuousRecognitionAsync();
        } catch (error) {
          console.warn("Failed to restart recognizer:", error);
        }
      }
    });
  };

  handleVoiceButtonClick = () => {
    console.log("Voice Button Clicked");
  };

  handleVoiceButtonPress = () => {
    try {
      this.recognizer.startContinuousRecognitionAsync();
      this.setState({ voiceOn: true });
    } catch (error) {
      console.error("Error starting voice recognition:", error);
    }
  };

  handleVoiceButtonRelease = () => {
    if (this.recognizer && this.state.voiceOn) {
      try {
        this.recognizer.stopContinuousRecognitionAsync();
        this.setState({ voiceOn: false });
      } catch (error) {
        console.error("Error stopping voice recognition:", error);
      }
    }
  };
  // ======================================================================

  addMessages = async (bubbleMessage, theRole) => {
    let message = { content: bubbleMessage, role: theRole };

    if (bubbleMessage) {
      const nextState = {
        messages: [...this.state.messages, message],
      };
      if (theRole === "assistant" && this.state.mode === "text") {
        nextState.isAxiTyping = false;
      }
      if ((theRole === "user") & this.state.recording) {
        this.setState(nextState, () => {
          this.updateStreamingMessage();
        });
      } else {
        this.setState(nextState);
      }
    }
  };

  updateMessages = (bubbleMessage, theRole) => {
    const message =
      theRole === "assistant"
        ? bubbleMessage
        : numberOfPeopleFilter(bubbleMessage);
    this.addMessages(message, theRole);
  };

  updateStreamingMessage = () => {
    const { messages } = this.state;
    const newMessages = [...messages];

    if (newMessages.length >= 2) {
      newMessages.splice(newMessages.length - 2, 1);
    }

    this.setState({ messages: newMessages });
  };

  renderedMessages() {
    const messages = this.state.messages; // this.props
    if (messages !== undefined) {
      return messages.map((message, index) => (
        <ChatSpeechBubble key={index} message={message} />
      ));
    }
  }

  updateTTSCompletionTime() {
    axios.get(backendUrl + "get_tts_completion_timestamp")
      .catch(error => {
        // Silently handle TTS completion timestamp errors - this is just for analytics
        console.warn("TTS completion timestamp tracking failed:", error.response?.status);
      });
  }

  queueOrRunFinalResponse(turnId, handler) {
    if (this.activeGenerateTurnId !== turnId) {
      return;
    }
    if (this.isProgressiveFillerPlaying) {
      this.pendingFinalResponseHandler = handler;
      return;
    }
    this.pendingFinalResponseHandler = null;
    handler();
  }

  flushQueuedFinalResponse(turnId) {
    if (this.activeGenerateTurnId !== turnId) {
      return;
    }
    if (this.isProgressiveFillerPlaying) {
      return;
    }
    if (!this.pendingFinalResponseHandler) {
      return;
    }
    const queued = this.pendingFinalResponseHandler;
    this.pendingFinalResponseHandler = null;
    queued();
  }

  stopProgressiveAckPolling() {
    if (this.progressiveAckStartTimerRef) {
      clearTimeout(this.progressiveAckStartTimerRef);
      this.progressiveAckStartTimerRef = null;
    }
    if (this.progressiveAckPollerRef) {
      clearInterval(this.progressiveAckPollerRef);
      this.progressiveAckPollerRef = null;
    }
    this.isProgressiveAckRequestInFlight = false;
  }

  confirmProgressiveFillerPlaying(turnId) {
    axios
      .post(
        backendUrl + "conversations/progressive-ack/playing?persist_session=false",
        { turn_id: String(turnId) }
      )
      .catch((error) => {
        console.warn("Progressive ack playback confirmation failed:", error?.response?.status || error.message);
      });
  }

  startProgressiveAckPolling(turnId, userPrompt) {
    this.stopProgressiveAckPolling();
    this.progressiveAckStartTimerRef = setTimeout(() => {
      this.requestProgressiveAck(turnId, userPrompt);
      this.progressiveAckPollerRef = setInterval(() => {
        this.requestProgressiveAck(turnId, userPrompt);
      }, 250);
    }, 900);
  }

  requestProgressiveAck(turnId, userPrompt) {
    if (
      this.activeGenerateTurnId !== turnId
      || this.isFinalResponseReady
      || this.hasProgressiveFillerPlayed
      || this.isProgressiveAckRequestInFlight
    ) {
      return;
    }
    this.isProgressiveAckRequestInFlight = true;

    axios
      .post(
        backendUrl + "conversations/progressive-ack?persist_session=false",
        { text_input: userPrompt, turn_id: String(turnId) }
      )
      .then((response) => {
        if (this.activeGenerateTurnId !== turnId || this.isFinalResponseReady || this.hasProgressiveFillerPlayed) {
          return;
        }

        const payload = response?.data || {};
        const fillerText = typeof payload.response === "string" ? payload.response.trim() : "";
        const skipReason = typeof payload.skip_reason === "string" ? payload.skip_reason : "";
        const terminalSkipReasons = new Set([
          "not_takeaway_order",
          "not_order_items_stage",
          "already_emitted",
          "already_reserved",
          "final_ready_early",
          "invalid_turn",
          "llm_timeout_or_empty",
          "state_only_turn",
          "option_selection",
          "non_item_takeaway_turn",
          "fulfillment_reply",
          "recent_filler_cooldown",
        ]);
        if ((!payload.eligible || !fillerText) && terminalSkipReasons.has(skipReason)) {
          this.stopProgressiveAckPolling();
          return;
        }
        if (!payload.eligible || !fillerText) {
          return;
        }

        if (this.state.mode === "text") {
          this.hasProgressiveFillerPlayed = true;
          this.isProgressiveFillerPlaying = true;
          this.stopProgressiveAckPolling();
          this.confirmProgressiveFillerPlaying(turnId);
          this.setState({ systemMessage: fillerText }, () => {
            this.updateMessages(fillerText, "assistant");
          });
          this.progressiveTextFillerTimerRef = setTimeout(() => {
            if (this.activeGenerateTurnId !== turnId) {
              return;
            }
            this.progressiveTextFillerTimerRef = null;
            this.isProgressiveFillerPlaying = false;
            this.flushQueuedFinalResponse(turnId);
          }, TEXT_PROGRESSIVE_FILLER_MIN_DISPLAY_MS);
          return;
        }

        textToSpeech(
          fillerText,
          this.state.elevenLabsVoiceId,
          this.state.elevenLabsLanguageCode,
          this.state.elevenLabsVoiceSettings,
          this.state.mappedPronunciation
        )
          .then((audioBlob) => {
            if (this.activeGenerateTurnId !== turnId || this.isFinalResponseReady) {
              return;
            }

            this.hasProgressiveFillerPlayed = true;
            this.isProgressiveFillerPlaying = true;
            this.stopProgressiveAckPolling();
            this.confirmProgressiveFillerPlaying(turnId);
            this.setState({ systemMessage: fillerText }, () => {
              this.updateMessages(this.state.systemMessage, "assistant");
            });
            this.playFillerAudio(URL.createObjectURL(audioBlob), () => {
              if (this.activeGenerateTurnId !== turnId) {
                return;
              }
              this.isProgressiveFillerPlaying = false;
              this.flushQueuedFinalResponse(turnId);
            });
          })
          .catch((error) => {
            console.error("Progressive ack TTS error:", error);
          });
      })
      .catch((error) => {
        console.warn("Progressive ack unavailable:", error?.response?.status || error.message);
      })
      .finally(() => {
        this.isProgressiveAckRequestInFlight = false;
      });
  }

  handleTextResponsePayload(payload) {
    if (payload.response.includes("AxiComplete")) {
      this.finishRecognization = true;
      axios.get(backendUrl + "conversations/note").then((response) => {
        const fakeMessage = response.data;
        if (!fakeMessage) {
          this.getSummary();
          return;
        }
        this.setState({ systemMessage: fakeMessage }, () => {
          this.updateMessages(fakeMessage, "assistant");
        });
        this.getSummary();
      });
      return;
    }

    if (payload.response.includes("RedirectHuman")) {
      this.finishRecognization = true;
      // Being redirected to a human ends the conversation: release the mic and
      // lock the input via the "complete" state.
      this.releaseMicrophone();
      axios.post(backendUrl + "conversations/redirect-human").then((response) => {
        const text = response.data.response;
        this.setState({ systemMessage: text, systemStatus: "complete" }, () => {
          this.updateMessages(text, "assistant");
          this.updateTTSCompletionTime();
        });
      });
      return;
    }

    if (payload.response.includes("GetRecommendation")) {
      const fakeMessage =
        this.state.integrationType === "direct"
          ? FAKE_MESSAGES["GetRecommendation"][this.props.langName]
          : FAKE_MESSAGES_RPA["GetRecommendation"][this.props.langName];
      this.setState({ systemMessage: fakeMessage }, () => {
        this.updateMessages(fakeMessage, "assistant");
      });
      axios.get(backendUrl + "triggerRecommendation").then((response) => {
        this.setState(
          { systemMessage: response.data.response, systemStatus: "idle" },
          () => {
            this.updateMessages(response.data.response, "assistant");
            this.updateTTSCompletionTime();
          }
        );
      });
      return;
    }

    this.setState(
      { systemMessage: payload.response, systemStatus: "idle" },
      () => {
        this.updateMessages(payload.response, "assistant");
        this.updateTTSCompletionTime();
      }
    );
  }

  handleGenerateResponsePayload(payload) {
    if (this.state.mode === "text") {
      this.handleTextResponsePayload(payload);
      return;
    }
    // if completely collected all information
    if (payload.response.includes("AxiComplete")) {
      this.finishRecognization = true;
      axios.get(backendUrl + "conversations/note").then((response) => {
        const fakeMessage = response.data;
        if (!fakeMessage) {
          this.getSummary();
          return;
        }
        textToSpeech(fakeMessage, this.state.elevenLabsVoiceId, this.state.elevenLabsLanguageCode, this.state.elevenLabsVoiceSettings, this.state.mappedPronunciation).then(
          (audioBlob) => {
            this.setState({ systemMessage: fakeMessage }, () => {
              this.updateMessages(this.state.systemMessage, "assistant");
            });
            this.playFillerAudio(URL.createObjectURL(audioBlob));
            if (this.state.integrationType === "rpa") {
              setTimeout(() => {
                this.playOnHoldMusic(0);
              }, 1000);
            }
            this.getSummary();
          }
        );
      });
      return;
    }

    if (payload.response.includes("RedirectHuman")) {
      this.finishRecognization = true;
      // Being redirected to a human ends the conversation: release the mic and
      // lock the input via the "complete" state.
      this.releaseMicrophone();
      axios
        .post(backendUrl + "conversations/redirect-human")
        .then((response) => {
          response = response.data.response;
          textToSpeech(response, this.state.elevenLabsVoiceId, this.state.elevenLabsLanguageCode, this.state.elevenLabsVoiceSettings, this.state.mappedPronunciation).then((audioBlob) => {
            this.updateTTSCompletionTime();
            this.setState({ systemMessage: response }, () => {
              this.updateMessages(this.state.systemMessage, "assistant");
            });
            this.playSystemAudio(URL.createObjectURL(audioBlob));
          });
        });
      this.setState({ systemStatus: "complete" });
      return;
    }

    if (payload.response.includes("GetRecommendation")) {
      let fakeMessage = "";
      if (this.state.integrationType === "direct") {
        fakeMessage =
          FAKE_MESSAGES["GetRecommendation"][this.props.langName];
      } else {
        fakeMessage =
          FAKE_MESSAGES_RPA["GetRecommendation"][this.props.langName];
      }
      textToSpeech(fakeMessage, this.state.elevenLabsVoiceId, this.state.elevenLabsLanguageCode, this.state.elevenLabsVoiceSettings, this.state.mappedPronunciation).then((audioBlob) => {
        this.setState({ systemMessage: fakeMessage }, () => {
          this.updateMessages(this.state.systemMessage, "assistant");
        });
        this.playFillerAudio(URL.createObjectURL(audioBlob), () => {
          this.setState({ playing: true });
        });
        this.recognizer.stopContinuousRecognitionAsync();
        if (this.state.integrationType === "rpa") {
          setTimeout(() => {
            this.playOnHoldMusic(0);
          }, 1000);
        }
      });

      axios.get(backendUrl + "triggerRecommendation").then((response) => {
        textToSpeech(response.data.response, this.state.elevenLabsVoiceId, this.state.elevenLabsLanguageCode, this.state.elevenLabsVoiceSettings, this.state.mappedPronunciation)
          .then((audioBlob) => {
            this.updateTTSCompletionTime();
            this.setState({ systemMessage: response.data.response }, () => {
              this.updateMessages(this.state.systemMessage, "assistant");
            });
            if (this.state.integrationType === "rpa") {
              this.stopOnHoldMusic();
            }
            this.playSystemAudio(URL.createObjectURL(audioBlob));
            this.recognizer.startContinuousRecognitionAsync();
          })
          .catch((error) => {
            console.error("Error at postGenerateResult:", error);
          });
      });
      this.setState({ systemStatus: "idle" });
      return;
    }

    textToSpeech(payload.response, this.state.elevenLabsVoiceId, this.state.elevenLabsLanguageCode, this.state.elevenLabsVoiceSettings, this.state.mappedPronunciation)
      .then((audioBlob) => {
        this.updateTTSCompletionTime();
        this.setState({ systemMessage: payload.response }, () => {
          this.updateMessages(this.state.systemMessage, "assistant");
        });
        this.setState({ systemMessage: payload.response });
        this.playSystemAudio(URL.createObjectURL(audioBlob));
      })
      .catch((error) => {
        console.error("TTS error:", error);
      });
  }

  handleGenerateResponseError(error, turnId) {
    if (this.activeGenerateTurnId !== turnId) {
      return;
    }

    this.isFinalResponseReady = true;
    this.pendingFinalResponseHandler = null;
    if (this.progressiveTextFillerTimerRef) {
      clearTimeout(this.progressiveTextFillerTimerRef);
      this.progressiveTextFillerTimerRef = null;
    }
    this.isProgressiveFillerPlaying = false;
    this.stopProgressiveAckPolling();

    if (this.recognizer && this.recognizer.stopContinuousRecognitionAsync) {
      try {
        this.recognizer.stopContinuousRecognitionAsync();
      } catch (stopError) {
        console.warn("Failed to stop recognizer after generate-response error:", stopError);
      }
    }

    const errorDetails = error?.response?.data || error?.message || error;
    console.error("Generate response failed:", errorDetails);
    this.setState(
      {
        isAxiTyping: false,
        systemStatus: "idle",
        systemMessage: generateResponseErrorMessage,
      },
      () => {
        this.updateMessages(generateResponseErrorMessage, "assistant");
      }
    );
  }

  postGenerateResult() {
    this.setState({ systemStatus: "waiting" });
    const userPrompt = this.state.userMessage;

    const turnId = this.activeGenerateTurnId + 1;
    this.activeGenerateTurnId = turnId;
    this.pendingFinalResponseHandler = null;
    if (this.progressiveTextFillerTimerRef) {
      clearTimeout(this.progressiveTextFillerTimerRef);
      this.progressiveTextFillerTimerRef = null;
    }
    this.isProgressiveFillerPlaying = false;
    this.hasProgressiveFillerPlayed = false;
    this.isFinalResponseReady = false;
    this.isProgressiveAckRequestInFlight = false;

    const data = {
      text_input: userPrompt,
      turn_id: String(turnId),
    };

    this.startProgressiveAckPolling(turnId, userPrompt);

    axios
      .post(backendUrl + "conversations/generate-response", data)
      .then((response) => {
        if (this.activeGenerateTurnId !== turnId) {
          return;
        }

        this.isFinalResponseReady = true;
        this.stopProgressiveAckPolling();

        this.queueOrRunFinalResponse(turnId, () => {
          this.handleGenerateResponsePayload(response.data);
        });
      })
      .catch((error) => {
        this.handleGenerateResponseError(error, turnId);
      });
  }

  getSummary() {
    axios.post(backendUrl + "conversations/summary", {}).then((response) => {
      // const smsMessage = response.data.confirmationMessage

      if (this.state.mode === "text") {
        this.setState(
          {
            systemMessage: response.data.response,
            calendarData: response.data.calendar_info,
            systemStatus: "complete",
            lastMessage: { content: response.data.response },
          },
          () => {
            this.updateMessages(response.data.response, "assistant");
            this.updateTTSCompletionTime();
            // Conversation is over: release the mic immediately.
            this.releaseMicrophone();
          }
        );
        return;
      }

      textToSpeech(response.data.response, this.state.elevenLabsVoiceId, this.state.elevenLabsLanguageCode, this.state.elevenLabsVoiceSettings, this.state.mappedPronunciation)
        .then((audioBlob) => {
          if (this.state.integrationType === "rpa") {
            this.stopOnHoldMusic();
          }
          this.updateTTSCompletionTime();
          this.setState(
            {
              systemMessage: response.data.response,
              calendarData: response.data.calendar_info,
              systemStatus: "complete",
            },
            () => {
              // The standalone summary card is removed, so make sure the
              // summary always lands in the chat transcript (voice mode
              // otherwise only speaks it via TTS).
              this.updateMessages(response.data.response, "assistant");
              this.setState({
                lastMessage: { content: this.state.systemMessage },
                systemStatus: "complete",
              });
            }
          );
          this.playSystemAudio(URL.createObjectURL(audioBlob));
          // Conversation is over: release the mic immediately (recognizer +
          // preflight stream). Summary TTS uses this.audio, so it is untouched.
          this.releaseMicrophone();
        })
        .then(this.setState({ systemStatus: "complete" }));
    });
  }

  handleStartTextConversation() {
    this.setState({ systemStatus: "waiting", isAxiTyping: true });
    axios.post(backendUrl + "clear-session").then(() => {
      clearStoredSessionId();
      axios
        .post(backendUrl + "conversations/start", {
          text_input: this.props.language,
          place: this.state.servicePlace,
        })
        .then((response) => {
          storeSessionIdFromResponse(response);
          const { VoiceID, DisplayName, SimilarityBoost, Speed, Stability } =
            response.data.voice_settings;
          const shortenedLanguageCode = this.state.language.substring(0, 2);
          const elevenLabsVoiceSettings = {
            stability: Stability,
            similarity_boost: SimilarityBoost,
            speed: Speed,
          };

          this.setState(
            {
              systemMessage: response.data.welcome_message,
              nameList: "Available Locations: " + response.data.location_name,
              voiceSettings: response.data.voice_settings,
              mappedPronunciation: response.data.mapped_pronunciation,
              elevenLabsVoiceId: VoiceID,
              elevenLabsVoiceDisplayName: DisplayName,
              elevenLabsVoiceSettings: elevenLabsVoiceSettings,
              elevenLabsLanguageCode: shortenedLanguageCode,
              started: true,
              systemStatus: "idle",
            },
            () => {
              this.updateMessages(response.data.welcome_message, "assistant");
            }
          );
        });
    });
  }

  handleStartConversation() {
    this.setState({ audioStream: this.props.audioStream }, () => {
      this.startRecording();
      this.setState({ systemStatus: "waiting" });
      // clear session
      axios.post(backendUrl + "clear-session").then(() => {
        clearStoredSessionId();
        axios
          .post(backendUrl + "conversations/start", {
            text_input: this.props.language,
            place: this.state.servicePlace,
          })
          .then((response) => {
            storeSessionIdFromResponse(response);
            const { VoiceID, DisplayName, SimilarityBoost, Speed, Stability } = response.data.voice_settings;
            const shortenedLanguageCode = this.state.language.substring(0,2);
            const elevenLabsVoiceSettings = {
              stability: Stability,
              similarity_boost: SimilarityBoost,
              speed: Speed
            }

            this.setState(
              {
                systemMessage: response.data.welcome_message,
                nameList: "Available Locations: " + response.data.location_name,
                voiceSettings: response.data.voice_settings,
                mappedPronunciation: response.data.mapped_pronunciation,
                elevenLabsVoiceId: VoiceID,
                elevenLabsVoiceDisplayName: DisplayName,
                elevenLabsVoiceSettings: elevenLabsVoiceSettings,
                elevenLabsLanguageCode: shortenedLanguageCode,
              },
              () => {
                this.updateMessages(this.state.systemMessage, "assistant");
              }
            );

            const phraseList = speechsdk.PhraseListGrammar.fromRecognizer(
              this.recognizer
            );

            response.data.phrase_list.forEach((phrase) => {
              let words = phrase.split(" ");
              if (words.length > 1) {
                words.forEach((word) => {
                  phraseList.addPhrases(word);
                });
              }
              phraseList.addPhrases(phrase);
            });

            textToSpeech(
              response.data.welcome_message,
              VoiceID,
              shortenedLanguageCode,
              elevenLabsVoiceSettings,
              response.data.mapped_pronunciation
            ).then((audioBlob) => {
              const audio = new Audio(URL.createObjectURL(audioBlob));
              this.setState({ welcomeAudio: audio }, () => {
                this.setState({ started: true });
                this.playSystemAudio(URL.createObjectURL(audioBlob));
              });
            });
          });
      });
    });
  }

  playFillerAudio(audio, end_callback = null) {
    if (this.audio !== undefined) {
      this.audio.pause();
      this.setState({ systemStatus: "idle" });
      this.audio.src = audio;
    } else {
      this.audio = audio;
    }

    this.audio.onended = () => {
      if (end_callback !== null) {
        end_callback();
      }
      this.setState({
        systemStatus: "waiting",
        playing: false,
        axiSpeaking: false,
      });
    };
    if (this.state.playing === false) {
      this.setState({ playing: true, axiSpeaking: true });
    }
    this.audio.play();
  }

  playSystemAudio(audio, end_callback = null) {
    if (this.audio !== undefined) {
      this.audio.pause();
      // Keep the finished state locked once the conversation has ended
      // (summary or redirect); otherwise fall back to the active "idle" state.
      this.setState({
        systemStatus: this.finishRecognization ? "complete" : "idle",
      });

      this.audio.src = audio;
    } else {
      this.audio = audio;
    }

    this.audio.onended = () => {
      if (end_callback !== null) {
        end_callback();
      }
      this.setState({
        // If the conversation is finished (summary already delivered), keep the
        // "complete" state so the input stays locked instead of reopening.
        systemStatus: this.finishRecognization ? "complete" : "idle",
        playing: false,
        axiSpeaking: false,
      });
    };
    if (this.state.playing === false) {
      this.setState({ playing: true, axiSpeaking: true });
    }
    this.audio.play();
  }

  playOnHoldMusic(currTime) {
    setTimeout(() => {
      this.setState({
        systemStatus: "waiting",
        playing: false,
        axiSpeaking: false,
      });
      this.audio.src = this.onHoldMusic.src;
      this.audio.currentTime = currTime;
      this.audio.play();
    }, 7000);
  }

  stopOnHoldMusic() {
    this.audio.pause();
    this.audio.currentTime = 0;
  }

  startRecording() {
    this.setState({ userMessage: "" });

    const speechConfig = speechsdk.SpeechConfig.fromSubscription(
      apiKey,
      region
    );
    const audioConfig = speechsdk.AudioConfig.fromDefaultMicrophoneInput();
    speechConfig.speechRecognitionLanguage = this.state.language;
    this.recognizer = new speechsdk.SpeechRecognizer(speechConfig, audioConfig);

    // add service places to phrase list
    const phraseList = speechsdk.PhraseListGrammar.fromRecognizer(
      this.recognizer
    );
    phraseList.addPhrase(this.state.servicePlace);
    phraseList.addPhrase("at " + this.state.servicePlace);

    this.recognizer.startContinuousRecognitionAsync();
    this.recognizer.recognizing = (_, e) => {
      this.recognizer.recognizing = (_, e) => {
        if (this.audio.paused) {
          if (this.state.axiSpeaking === false) {
            this.updateMessages(e.result.text, "user");
            this.setState({
              recording: true,
              systemStatus: true,
              userMessage: e.result.text,
              playing: true,
              role: "user",
              waveformData: axifyWaveformUser,
            });
          }
        }
      }
    };

    this.recognizer.recognized = (_, e) => {
      if (this.state.axiSpeaking === false) {
        this.setState({
          recording: false,
          playing: false,
          role: "assistant",
          waveformData: axifyWaveformAxi,
        });
      } else {
        this.setState({
          recording: false,
          role: "assistant",
          waveformData: axifyWaveformAxi,
        });
      }

      if (e.result.reason === speechsdk.ResultReason.RecognizedSpeech) {
        if (this.audio.paused) {
          if (!this.finishRecognization) {
            this.updateMessages(e.result.text, "user");
            this.setState({ userMessage: e.result.text }, () => {
              this.postGenerateResult();
            });
          }
        }
      }
    }
  }

  // scroll to bottom of chat window when new messages are added
  componentDidUpdate(prevProps) {
    const chatScroll = document.querySelector(".axify__widget-chat-scroller");
    if (chatScroll) {
      chatScroll.scrollTop = chatScroll.scrollHeight;
    }
  }

  componentDidMount() {
    if (this.state.started) {
      if (this.state.mode === "text") {
        this.handleStartTextConversation();
      } else {
        this.handleStartConversation();
      }
    }
  }

  componentWillUnmount() {
    this.teardownSession();
  }

  // Release the microphone only: stop + dispose the speech recognizer (which
  // frees Azure SDK's internal mic) and stop the app-level preflight mic
  // stream. Does NOT touch audio playback, so the summary TTS keeps playing.
  // Idempotent — safe to call multiple times.
  releaseMicrophone() {
    // Stop + dispose the speech recognizer (releases Azure's mic).
    if (this.recognizer) {
      try {
        this.recognizer.stopContinuousRecognitionAsync(
          () => {
            try {
              this.recognizer && this.recognizer.close();
            } catch (e) {
              /* noop */
            }
            this.recognizer = null;
          },
          (err) => {
            console.warn("Failed to stop recognizer:", err);
            try {
              this.recognizer && this.recognizer.close();
            } catch (e) {
              /* noop */
            }
            this.recognizer = null;
          }
        );
      } catch (error) {
        console.warn("Recognizer stop error:", error);
        this.recognizer = null;
      }
    }

    // Stop the app-level preflight mic stream. audioStream may be a
    // MediaStream or (see App.js) a Promise that resolves to one.
    const stopTracks = (stream) => {
      if (stream && typeof stream.getTracks === "function") {
        stream.getTracks().forEach((track) => {
          try {
            track.stop();
          } catch (e) {
            /* noop */
          }
        });
      }
    };
    const audioStream = this.props.audioStream;
    if (audioStream && typeof audioStream.then === "function") {
      Promise.resolve(audioStream).then(stopTracks).catch(() => {});
    } else {
      stopTracks(audioStream);
    }
  }

  // Fully tear down the live session: release the microphone, halt any audio
  // playback/polling, and clear the backend session. Called on close (X /
  // programmatic) and on unmount. Every step is idempotent, so it is safe to
  // call multiple times.
  teardownSession() {
    // 1 & 2. Release the microphone (recognizer + preflight stream).
    this.releaseMicrophone();

    // 3. Halt any audio playback and background polling.
    try {
      this.audio && this.audio.pause();
    } catch (e) {
      /* noop */
    }
    try {
      this.onHoldMusic && this.onHoldMusic.pause();
    } catch (e) {
      /* noop */
    }
    this.stopProgressiveAckPolling();
    if (this.progressiveTextFillerTimerRef) {
      clearTimeout(this.progressiveTextFillerTimerRef);
      this.progressiveTextFillerTimerRef = null;
    }
    this.finishRecognization = true;

    // 4. Clear the backend session.
    try {
      axios.post(backendUrl + "clear-session").catch(() => {});
    } catch (e) {
      /* noop */
    }
    clearStoredSessionId();
  }

  render() {
    // Once the summary is delivered the session is finished — lock the input
    // so the user can no longer type/speak or switch modes.
    const isComplete = this.state.systemStatus === "complete";
    return (
      <main
        id={"axify__widget-" + this.props.appId + "-content"}
        className="axify__widget-content"
      >
        <section
          id={"axify__widget-" + this.props.appId + "-chat-ui"}
          className="axify__widget-chat-ui"
        >
          <div className="axify__widget-chat-scroller">
            <div
              className="axify__widget-chat-transcript"
              role="log"
              aria-live="polite"
              aria-label="Chat Transcript"
              tabIndex="0"
            >
              {this.renderedMessages()}
              {this.state.mode === "text" && this.state.isAxiTyping && (
                <div
                  className="transcript-item role assistant axi-typing-indicator"
                  aria-label="Axi is typing"
                  aria-live="polite"
                >
                  <figure aria-hidden="true">
                    <img
                      src={axiSymbolWhite}
                      width="44"
                      height="44"
                      alt="Axi Symbol"
                    />
                  </figure>
                  <div aria-hidden="true">
                    <span className="axi-typing-dots">
                      <span></span>
                      <span></span>
                      <span></span>
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div>
              {/* Summary is shown inline in the transcript above; no separate
                  summary card/overlay to avoid duplicating the message. */}
              <div></div>
            </div>
            <div className="bottom" aria-hidden="true"></div>
          </div>
          <div
            id={"axify__widget-" + this.props.appId + "-input-ui"}
            className="axify__widget-input-ui"
          >
            {isComplete ? (
              <p
                className="axify__widget-conversation-ended"
                aria-live="polite"
              >
                This conversation has ended.
              </p>
            ) : (
              <>
            <button
              type="button"
              className="axify__widget-mode-toggle"
              onClick={this.handleModeSwitch}
              aria-label={
                this.state.mode === "voice"
                  ? "Switch to text chat"
                  : "Switch to voice"
              }
            >
              {this.state.mode === "voice"
                ? "Switch to Chat"
                : "Switch to Voice"}
            </button>
            {this.state.mode === "text" ? (
              // Text mode: chat input only
              <div className="axify__widget-chat-text-input">
                <input
                  type="text"
                  value={this.state.inputText}
                  onChange={this.handleInputChange}
                  onKeyPress={this.handleKeyPress}
                  placeholder="Type your message..."
                  aria-label="Message"
                />
                <button
                  type="button"
                  onClick={this.handleSend}
                  className="axify__widget-chat-text-send"
                  aria-label="Send message"
                >
                  Send
                </button>
              </div>
            ) : (
              // Voice mode: italic hint + waveform
              <>
                <p
                  className="axify__widget-voice-hint"
                  aria-live="polite"
                >
                  {this.state.axiSpeaking
                    ? "Axi is speaking…"
                    : this.state.recording
                    ? "Listening…"
                    : "Tap to speak with the concierge"}
                </p>
                <div
                  id={"axify__widget-" + this.props.appId + "-waveform"}
                  className={
                    "axify__widget-waveform " +
                    this.state.role +
                    " " +
                    this.state.systemStatus
                  }
                >
                  <ChatWaveform
                    waveformData={this.state.waveformData}
                    playing={this.state.playing}
                    axiSpeaking={this.state.axiSpeaking}
                  />
                </div>
              </>
            )}
              </>
            )}
          </div>
        </section>
      </main>
    );
  }
}

export default ChatMessages;
